import React from 'react';
import { Beer, Utensils, Coffee, FileText } from 'lucide-react';
import { businessData } from '../data/mock';
import './Products.css';

const productIcons = {
  'Cerveza Artesanal': Beer,
  'Picadas': Utensils,
  'Comida': Coffee
};

const Products = () => {
  const handleMenuClick = (e) => {
    e.preventDefault();
    // TODO: En el futuro, esto abrirá un PDF con la carta
    alert('Próximamente: Carta completa en PDF');
  };

  return (
    <section id="productos" className="products section">
      <div className="products__container container">
        <div className="products__header">
          <h2 className="section-title">Qué ofrecemos</h2>
          <p className="section-subtitle">
            Productos de calidad para disfrutar en un ambiente único.
          </p>
        </div>
        
        <div className="products__grid">
          {businessData.products.map((product, index) => {
            const IconComponent = productIcons[product.name] || Beer;
            return (
              <div key={index} className="products__card">
                <div className="products__card-icon">
                  <IconComponent size={40} />
                </div>
                <h3 className="products__card-title">{product.name}</h3>
                <p className="products__card-description">{product.description}</p>
              </div>
            );
          })}
        </div>
        
        <div className="products__menu-action">
          <button 
            onClick={handleMenuClick}
            className="btn btn-secondary products__menu-btn"
          >
            <FileText size={20} />
            Ver Carta
          </button>
        </div>
      </div>
    </section>
  );
};

export default Products;
